"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitDomainTld = exports.getParsedAllDomainsNftAccountsByOwner = exports.delay = exports.performReverseLookupBatched = exports.findMetadataAddress = exports.findNameHouse = exports.findTldHouse = exports.findNftRecord = exports.getMintOwner = exports.findAllDomainsForTld = exports.getParentAccountFromTldHouseAccountInfo = exports.getTldFromTldHouseAccountInfo = exports.getAllTld = exports.findMainDomain = exports.findOwnedNameAccountsForUser = exports.getOriginNameAccountKey = exports.getHashedName = exports.getNameOwner = exports.getNameAccountKeyWithBump = void 0;
const web3_js_1 = require("@solana/web3.js");
const bn_js_1 = require("bn.js");
const sha2_1 = require("@ethersproject/sha2");
const constants_1 = require("./constants");
const name_record_header_1 = require("./state/name-record-header");
const tag_1 = require("./types/tag");
const nft_record_1 = require("./state/nft-record");
/**
 * retrieves raw name account
 *
 * @param hashedName hashed name of the name account
 * @param nameClass defaults to pubkey::default()
 * @param parentName defaults to pubkey::default()
 */
function getNameAccountKeyWithBump(hashedName, nameClass, parentName) {
    const seeds = [
        hashedName,
        nameClass ? nameClass.toBuffer() : Buffer.alloc(32),
        parentName ? parentName.toBuffer() : Buffer.alloc(32),
    ];
    return web3_js_1.PublicKey.findProgramAddressSync(seeds, constants_1.ANS_PROGRAM_ID);
}
exports.getNameAccountKeyWithBump = getNameAccountKeyWithBump;
/**
 * retrieves owner of the name account
 *
 * @param connection sol connection
 * @param nameAccountKey nameAccount to get owner of.
 */
function getNameOwner(connection, nameAccountKey, tldHouse) {
    return __awaiter(this, void 0, void 0, function* () {
        const nameAccount = yield name_record_header_1.NameRecordHeader.fromAccountAddress(connection, nameAccountKey);
        const owner = nameAccount.owner;
        if (!nameAccount.isValid)
            return undefined;
        if (!tldHouse)
            return owner;
        const [nameHouse] = findNameHouse(tldHouse);
        const [nftRecord] = findNftRecord(nameAccountKey, nameHouse);
        if ((owner === null || owner === void 0 ? void 0 : owner.toBase58()) !== nftRecord.toBase58())
            return owner;
        return yield getMintOwner(connection, nftRecord);
    });
}
exports.getNameOwner = getNameOwner;
/**
 * computes hashed name
 *
 * @param name any string or domain name.
 */
function getHashedName(name) {
    return __awaiter(this, void 0, void 0, function* () {
        const input = name_record_header_1.NameRecordHeader.HASH_PREFIX + name;
        const str = (0, sha2_1.sha256)(Buffer.from(input, 'utf8')).slice(2);
        return Buffer.from(str, 'hex');
    });
}
exports.getHashedName = getHashedName;
/**
 * A constant in tld house.
 *
 * get origin name account should always equal to 3mX9b4AZaQehNoQGfckVcmgmA6bkBoFcbLj9RMmMyNcU
 *
 * @param originTld
 */
function getOriginNameAccountKey(originTld = constants_1.ORIGIN_TLD) {
    return __awaiter(this, void 0, void 0, function* () {
        const hashed_name = yield getHashedName(originTld);
        const [nameAccountKey] = getNameAccountKeyWithBump(hashed_name, undefined, undefined);
        return nameAccountKey;
    });
}
exports.getOriginNameAccountKey = getOriginNameAccountKey;
/**
 * finds list of all name accounts for a particular user.
 *
 * @param connection sol connection
 * @param userAccount user's public key
 * @param parentAccount nameAccount's parentName
 */
function findOwnedNameAccountsForUser(connection, userAccount, parentAccount) {
    return __awaiter(this, void 0, void 0, function* () {
        const filters = [
            {
                memcmp: {
                    offset: 40,
                    bytes: userAccount.toBase58(),
                    encoding: 'base58',
                },
            },
        ];
        if (parentAccount) {
            filters.push({
                memcmp: {
                    offset: 8,
                    bytes: parentAccount.toBase58(),
                    encoding: 'base58',
                },
            });
        }
        const accounts = yield connection.getProgramAccounts(constants_1.ANS_PROGRAM_ID, {
            filters: filters
        });
        return accounts.map((a) => a.pubkey);
    });
}
exports.findOwnedNameAccountsForUser = findOwnedNameAccountsForUser;
function findMainDomain(user) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(constants_1.MAIN_DOMAIN_PREFIX), user.toBuffer()], constants_1.TLD_HOUSE_PROGRAM_ID);
}
exports.findMainDomain = findMainDomain;
/**
 * finds list of all tld house accounts live.
 *
 * @param connection sol connection
 */
function getAllTld(connection) {
    return __awaiter(this, void 0, void 0, function* () {
        const filters = [
            {
                memcmp: {
                    offset: 0,
                    bytes: "iQgos3SdaVE",
                },
            },
        ];
        const accounts = yield connection.getProgramAccounts(constants_1.TLD_HOUSE_PROGRAM_ID, {
            filters: filters,
        });
        const tldsAndParentAccounts = [];
        accounts.map(({ account }) => {
            const parentAccount = getParentAccountFromTldHouseAccountInfo(account);
            const tld = getTldFromTldHouseAccountInfo(account);
            tldsAndParentAccounts.push({ tld, parentAccount });
        });
        return tldsAndParentAccounts;
    });
}
exports.getAllTld = getAllTld;
function getTldFromTldHouseAccountInfo(tldHouseData) {
    var _a;
    const tldStart = 8 + 32 + 32 + 32;
    const tldBuffer = (_a = tldHouseData === null || tldHouseData === void 0 ? void 0 : tldHouseData.data) === null || _a === void 0 ? void 0 : _a.subarray(tldStart);
    const nameLength = new bn_js_1.BN(tldBuffer === null || tldBuffer === void 0 ? void 0 : tldBuffer.subarray(0, 4), 'le').toNumber();
    return tldBuffer
        .subarray(4, 4 + nameLength)
        .toString()
        .replace(/\0.*$/g, '');
}
exports.getTldFromTldHouseAccountInfo = getTldFromTldHouseAccountInfo;
function getParentAccountFromTldHouseAccountInfo(tldHouseData) {
    var _a;
    const parentAccountStart = 8 + 32 + 32;
    const parentAccountBuffer = (_a = tldHouseData === null || tldHouseData === void 0 ? void 0 : tldHouseData.data) === null || _a === void 0 ? void 0 : _a.subarray(parentAccountStart, parentAccountStart + 32);
    return new web3_js_1.PublicKey(parentAccountBuffer);
}
exports.getParentAccountFromTldHouseAccountInfo = getParentAccountFromTldHouseAccountInfo;
/**
 * finds list of all domains in parent account from tld.
 *
 * @param connection sol connection
 * @param parentAccount nameAccount's parentName
 */
function findAllDomainsForTld(connection, parentAccount) {
    return __awaiter(this, void 0, void 0, function* () {
        const filters = [
            {
                memcmp: {
                    offset: 8,
                    bytes: parentAccount.toBase58(),
                    encoding: 'base58',
                },
            },
        ];
        const accounts = yield connection.getProgramAccounts(constants_1.ANS_PROGRAM_ID, {
            filters: filters,
        });
        return accounts.map((a) => a.pubkey);
    });
}
exports.findAllDomainsForTld = findAllDomainsForTld;
function getMintOwner(connection, nftRecord) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const nftRecordData = yield nft_record_1.NftRecord.fromAccountAddress(connection, nftRecord);
            if (nftRecordData.tag !== tag_1.Tag.ActiveRecord)
                return;
            const largestAccounts = yield connection.getTokenLargestAccounts(nftRecordData.nftMintAccount);
            const largestAccountInfo = yield connection.getParsedAccountInfo(largestAccounts.value[0].address);
            if (!largestAccountInfo.value.data)
                return;
            // @ts-ignore
            return new web3_js_1.PublicKey(largestAccountInfo.value.data.parsed.info.owner);
        }
        catch (_a) {
            return undefined;
        }
    });
}
exports.getMintOwner = getMintOwner;
function findNftRecord(nameAccount, nameHouseAccount) {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from(constants_1.NFT_RECORD_PREFIX),
        nameHouseAccount.toBuffer(),
        nameAccount.toBuffer(),
    ], constants_1.NAME_HOUSE_PROGRAM_ID);
}
exports.findNftRecord = findNftRecord;
function findTldHouse(tldString) {
    tldString = tldString.toLowerCase();
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(constants_1.TLD_HOUSE_PREFIX), Buffer.from(tldString)], constants_1.TLD_HOUSE_PROGRAM_ID);
}
exports.findTldHouse = findTldHouse;
function findNameHouse(tldHouse) {
    return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(constants_1.NAME_HOUSE_PREFIX), tldHouse.toBuffer()], constants_1.NAME_HOUSE_PROGRAM_ID);
}
exports.findNameHouse = findNameHouse;
const findMetadataAddress = (mint) => {
    return web3_js_1.PublicKey.findProgramAddressSync([
        Buffer.from('metadata'),
        constants_1.TOKEN_METADATA_PROGRAM_ID.toBuffer(),
        mint.toBuffer(),
    ], constants_1.TOKEN_METADATA_PROGRAM_ID)[0];
};
exports.findMetadataAddress = findMetadataAddress;
function performReverseLookupBatched(connection, nameAccounts, tldHouse) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = nameAccounts.map((nameAccount) => __awaiter(this, void 0, void 0, function* () {
            const reverseLookupHashedName = yield getHashedName(nameAccount.toBase58());
            const [reverseLookUpAccount] = getNameAccountKeyWithBump(reverseLookupHashedName, tldHouse, undefined);
            return reverseLookUpAccount;
        }));
        const reverseLookUpAccounts = yield Promise.all(promises);
        const reverseLookupAccountInfos = yield connection.getMultipleAccountsInfo(reverseLookUpAccounts);
        return reverseLookupAccountInfos.map(reverseLookupAccountInfo => {
            const domain = reverseLookupAccountInfo === null || reverseLookupAccountInfo === void 0 ? void 0 : reverseLookupAccountInfo.data.subarray(name_record_header_1.NameRecordHeader.byteSize, reverseLookupAccountInfo === null || reverseLookupAccountInfo === void 0 ? void 0 : reverseLookupAccountInfo.data.length).toString();
            return domain;
        });
    });
}
exports.performReverseLookupBatched = performReverseLookupBatched;
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.delay = delay;
const getParsedAllDomainsNftAccountsByOwner = (owner, connection, expectedCreator) => __awaiter(void 0, void 0, void 0, function* () {
    const { value: splAccounts } = yield connection.getParsedTokenAccountsByOwner(owner, {
        programId: constants_1.SPL_TOKEN_PROGRAM_ID,
    });
    const nftAccounts = splAccounts
        .filter(t => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const amount = (_e = (_d = (_c = (_b = (_a = t.account) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.parsed) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.tokenAmount) === null || _e === void 0 ? void 0 : _e.uiAmount;
        const decimals = (_k = (_j = (_h = (_g = (_f = t.account) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.parsed) === null || _h === void 0 ? void 0 : _h.info) === null || _j === void 0 ? void 0 : _j.tokenAmount) === null || _k === void 0 ? void 0 : _k.decimals;
        return decimals === 0 && amount === 1;
    })
        .map(t => {
        var _a, _b, _c, _d;
        const address = (_d = (_c = (_b = (_a = t.account) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.parsed) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.mint;
        return address;
    });
    const ownerDomains = yield getOwnedDomains(nftAccounts, connection, expectedCreator);
    return ownerDomains;
});
exports.getParsedAllDomainsNftAccountsByOwner = getParsedAllDomainsNftAccountsByOwner;
const getOwnedDomains = (nftAddresses, connection, expectedCreator) => __awaiter(void 0, void 0, void 0, function* () {
    const ownedDomains = [];
    const verifiedCreatorByteOffset = 326;
    const verifiedCreatorVerfiiedByteOffset = 326;
    if (nftAddresses.length > 100) {
        while (nftAddresses.length > 0) {
            let nftMetadataKeys = nftAddresses
                .splice(0, 100)
                .map((mint) => (0, exports.findMetadataAddress)(new web3_js_1.PublicKey(mint)));
            const nftsMetadata = yield connection.getMultipleAccountsInfo(nftMetadataKeys);
            for (const nftMetadata of nftsMetadata) {
                if (nftMetadata) {
                    const verifiedCreatorAddress = new web3_js_1.PublicKey(nftMetadata.data.subarray(verifiedCreatorByteOffset, verifiedCreatorByteOffset + 32));
                    const isVerified = Boolean(nftMetadata.data.subarray(verifiedCreatorVerfiiedByteOffset, verifiedCreatorVerfiiedByteOffset + 1));
                    if (isVerified &&
                        verifiedCreatorAddress.toString() ===
                            expectedCreator.toString()) {
                        const domainName = nftMetadata.data
                            .subarray(66, 101)
                            .toString()
                            .replace(/\u0000/g, '');
                        ownedDomains.push(domainName);
                    }
                }
            }
        }
    }
    else {
        let nftMetadataKeys = nftAddresses.map((mint) => (0, exports.findMetadataAddress)(new web3_js_1.PublicKey(mint)));
        const nftsMetadata = yield connection.getMultipleAccountsInfo(nftMetadataKeys);
        for (const nftMetadata of nftsMetadata) {
            if (nftMetadata) {
                const verifiedCreatorAddress = new web3_js_1.PublicKey(nftMetadata.data.subarray(verifiedCreatorByteOffset, verifiedCreatorByteOffset + 32));
                const isVerified = Boolean(nftMetadata.data.subarray(verifiedCreatorVerfiiedByteOffset, verifiedCreatorVerfiiedByteOffset + 1));
                if (isVerified &&
                    verifiedCreatorAddress.toString() ===
                        expectedCreator.toString()) {
                    const domainName = nftMetadata.data
                        .subarray(66, 101)
                        .toString()
                        .replace(/\u0000/g, '');
                    ownedDomains.push(domainName);
                }
            }
        }
    }
    return ownedDomains;
});
function splitDomainTld(domain) {
    const parts = domain.split('.');
    let tld = '', domainName = '', subdomain = '';
    if (parts.length === 1) {
        domainName = parts[0];
    }
    else {
        tld = '.' + parts[parts.length - 1];
        domainName = parts[parts.length - 2];
        subdomain = parts.slice(0, parts.length - 2).join('.');
    }
    return [tld, domainName, subdomain];
}
exports.splitDomainTld = splitDomainTld;
//# sourceMappingURL=utils.js.map